import { PublicClientApplication, LogLevel as MSALLogLevel, ILoggerCallback } from '@azure/msal-browser'
import { logger, LinkingJourneyOrigins } from '@vrw/data/src/utils'
import { VAA_AUTH_CLIENT_ID, VAA_AUTH_ISSUER } from '../config'
import { trackDatadogAction } from '@/dataImplementation/datadog'

class VaaAuthServiceClass {
  private readonly msalInstance: PublicClientApplication

  constructor() {
    this.msalInstance = new PublicClientApplication({
      auth: {
        clientId: VAA_AUTH_CLIENT_ID ?? '',
        authority: VAA_AUTH_ISSUER,
        knownAuthorities: ['avadeunloyaltyfcb2c.b2clogin.com', 'avateunloyaltyfcb2c.b2clogin.com', 'identity.virginatlantic.com'],
      },
      system: {
        loggerOptions: {
          loggerCallback: ((level: MSALLogLevel, message: string, containsPii: boolean): void => {
            if (containsPii) {
              return
            }

            let logLevel: keyof typeof logger
            switch (level) {
              case MSALLogLevel.Error:
                logLevel = 'error'
                break
              case MSALLogLevel.Warning:
                logLevel = 'warn'
                break
              default:
                logLevel = 'log'
            }

            const logData = {
              level: MSALLogLevel[level],
              message,
            }

            logger[logLevel]('MSAL Auth:', logData)
            trackDatadogAction('msal_auth_log', logData)
          }) as ILoggerCallback,
          piiLoggingEnabled: false,
          logLevel: MSALLogLevel.Info,
        },
      },
    })
  }

  async handleAuth(journeyName?: LinkingJourneyOrigins, basePath?: string): Promise<void> {
    let redirectUri: string | undefined

    switch (journeyName) {
      case LinkingJourneyOrigins.ACCOUNT:
        redirectUri = `${basePath}/account/link-accounts`
        break
      case LinkingJourneyOrigins.ONBOARDING:
        redirectUri = `${basePath}/onboarding/link-vaa`
        break
      default:
        redirectUri = undefined
        break
    }

    try {
      await this.msalInstance.handleRedirectPromise()
      await this.msalInstance.loginRedirect({
        scopes: ['openid'],
        redirectUri,
        prompt: `login`, // always force login
      })
    } catch (error) {
      logger.warn('VaaAuthService:handleAuth() error: ', error)
    }
  }

  async getToken(): Promise<{ idToken?: string }> {
    try {
      const response = await this.msalInstance.handleRedirectPromise()
      return { idToken: response?.idToken }
    } catch (error) {
      logger.warn('VaaAuthService:getToken() error: ', error)
    }
    return {}
  }
}

export const VaaAuthService = new VaaAuthServiceClass()
